module.exports = __webpack_public_path__ + "b8bfa89c533bc795e7182511b441a371.jpg";